import React, { useState } from "react"
import {
    Button,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Input,
    Link,
    Stack,
    Image,
    useDisclosure,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Box,
    CloseButton
} from '@chakra-ui/react';
import log from "../../assets/log.svg"
import resources from "../../api";
import { Navigate } from "react-router-dom";

export default function LoginPage() {

    const [loader, setLoader] = useState(false), [error, setError] = useState(false), [navigate, setNavigate] = useState(false)
    const {
        isOpen: isVisible,
        onClose,
        onOpen,
    } = useDisclosure({ defaultIsOpen: false })

    const CONFIG = {
        code: {
            type: "qr"
        }
    }

    async function auth(e: any) {
        e.preventDefault()
        setLoader(true)
        let fromData = new FormData(e.target)

        try {
            let res = await resources.auth.auth(fromData)
            if (res.status === 200) {

                let a = res.data
                localStorage.setItem("userToken", a.token.token);
                localStorage.setItem("userId", a.user.id);
                localStorage.setItem("userName", a.user.name);
                localStorage.setItem("userEmail", a.user.email);
                localStorage.setItem("userRole", a.user.roles);
                localStorage.setItem("CONFIG", JSON.stringify(CONFIG))
                if (a.user.roles == "CLIENT") {
                    localStorage.setItem("userCompany", a.user.company);
                }
                setLoader(false)
                setNavigate(true)

            }
        } catch (a) {
            setLoader(false)
            onOpen()
            setError(true)

        }

    }

    if (navigate) {
        return <Navigate to="/materials" replace={true} />
    }

    return (
        <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }}>
            <Flex p={8} flex={1} align={'center'} justify={'center'}>
                <Stack spacing={4} w={'full'} maxW={'md'}>
                    <Heading fontSize={'2xl'}>Sign in to your account</Heading>
                    <form onSubmit={auth}>
                        <FormControl id="email" isRequired>
                            <FormLabel>Email address</FormLabel>
                            <Input type="email" name="email" required />
                        </FormControl>
                        <FormControl id="password" isRequired>
                            <FormLabel>Password</FormLabel>
                            <Input type="password" name="password" required />
                        </FormControl>
                        <Stack spacing={10} style={{ marginTop: 20 }}>
                            <Button colorScheme="brand" variant={'solid'} type="submit" isLoading={loader}>
                                Sign in
                            </Button>
                        </Stack>
                    </form>

                    {isVisible && <Alert status='error' variant='left-accent'>
                        <AlertIcon />
                        <Box>
                            <AlertTitle>Error!</AlertTitle>
                            <AlertDescription>
                                Email address or password wrong
                            </AlertDescription>
                        </Box>
                        <CloseButton
                            alignSelf='flex-start'
                            position='relative'
                            right={-1}
                            top={-1}
                            onClick={onClose}
                        />
                    </Alert>}
                </Stack>


            </Flex>
            <Flex flex={1}>
                <Image
                    alt={'Login Image'}
                    objectFit={'cover'}
                    src={log}
                />
            </Flex>
        </Stack>
    );
}
